import { Injectable, signal } from '@angular/core';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';
import { PermRole, UserRole, RemoveRole } from '@/models/user-data.model';
import { Observable, tap } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class UserRolesEditorService {

  baseUrl = environment.landmark_API_URL + '/perms';

  selectedUserRoles = signal<UserRole[]>([]);
  removedRoles = signal<RemoveRole[]>([]);

  constructor(private http: HttpClient) {
    
  }


}
